import React from "react";
import PageFrame from "./PageFrame";
import Abs from "./Abs";

/**
 * Page 08 - The Texas Advantage.
 *
 * A dark page: base #666769 with a darker panel from x=468 across the full height down
 * to y=682. Left column carries the title, lede, two figures and the city photo; the
 * right panel lists six "# 1" claims.
 *
 * The city photo varies by office location and comes from the template registry.
 * Closings and aggregate volume are dashes until the services exist.
 */

const REASONS = [
    ['Top property investment in the U.S.',
     'Persistent capital inflows from in-state and out-of-state investors'],
    ['Highest state population growth since 2020',
     'Demand fundamentals continue to drive absorption'],
    ['For total goods exported nation-wide',
     'Houston anchors a globally connected logistics base'],
    ['U.S. metro for composite labor market & in migration',
     'Dallas leads the nation on the Milken Best-Performing Cities index'],
    ['Most affordable housing among top-10 U.S. cities',
     'Cost-of-living advantage continues to attract corporate relocation'],
    ['In Fortune 500 headquarters',
     'More HQs than any other state - concentrated tenant demand'],
];

// Baselines of the six "# 1" rows in the template.
const ROW_Y = [112, 196, 279, 363, 446, 530];

export default function TexasAdvantage({template, stats, pageNo, totalPages}) {
    return (
        <PageFrame fixed dark pageNo={pageNo} totalPages={totalPages}>
            <div className='bov-texas__panel'/>

            <Abs x={48} y={49}>
                <div className='bov-page__eyebrow'>THE TEXAS ADVANTAGE</div>
                <div className='bov-texas__title' style={{marginTop: '4px'}}>Texas.</div>
            </Abs>

            <Abs x={48} y={130} w={400}>
                <div className='bov-texas__lede'>
                    The top property investment market in the United States - and the operating
                    ground we know better than anyone.
                </div>
            </Abs>

            <Abs x={48} y={259} w={220}>
                <div className='bov-texas__statValue'>{stats.closings}</div>
                <div className='bov-texas__statLabel' style={{marginTop: '9px'}}>
                    <div>CLOSINGS  •  #1 INVESTMENT</div>
                    <div>TEAM IN THE SOUTHWEST</div>
                </div>
            </Abs>

            <Abs x={293} y={259} w={220}>
                <div className='bov-texas__statValue'>{stats.aggregateVolume}</div>
                <div className='bov-texas__statLabel' style={{marginTop: '9px'}}>
                    <div>IN AGGREGATE</div>
                    <div>SALES VOLUME</div>
                </div>
            </Abs>

            {/*
              * The skyline sits on a fixed left edge and a fixed bottom edge (682px); its
              * height follows the artwork's own aspect ratio, exactly as the templates place
              * it. Houston's is the height baked into the stylesheet, so only a combination
              * whose skyline is a different shape needs `cityImageHeight`.
              */}
            {template.cityImage ? (
                <img
                    className='bov-texas__cityImg'
                    src={template.cityImage}
                    alt=''
                    style={template.cityImageHeight
                        ? {height: `${template.cityImageHeight}px`, top: `${682 - template.cityImageHeight}px`}
                        : undefined}
                />
            ) : null}

            <Abs x={552} y={63}>
                <div className='bov-texas__panelTitle'>WHY TEXAS LEADS</div>
            </Abs>

            {/* Separators between the six claims, x 552..1021 */}
            {[97, 171, 251, 335, 421, 504, 596].map(y => (
                <Abs key={`rule-${y}`} x={552} y={y} w={469} className='bov-rule bov-rule--onDark'/>
            ))}

            {REASONS.map((reason, i) => (
                <Abs key={i} x={552} y={ROW_Y[i]} w={470}>
                    <div style={{display: 'flex', alignItems: 'flex-start'}}>
                        <div className='bov-texas__rank' style={{flex: '0 0 70px'}}># 1</div>
                        <div className='bov-texas__reason'>
                            {reason.map((line, j) => <div key={j}>{line}</div>)}
                        </div>
                    </div>
                </Abs>
            ))}
        </PageFrame>
    );
}
